import http from 'services/http'
import useState from './useState'

export default function useHttpGet({ url, sleep, authed = true }) {
  const [response, setResponse] = useState(null)
  const [getInProgress, setGetInProgress] = useState(false)

  const get = async (params) => {
    setGetInProgress(true)
    try {
      const method = authed ? http.getAuthed : http.get
      const request = method(url, params)
      if (sleep) {
        await http.sleep(sleep)
      }
      setResponse(await request)
      return response.value
    } finally {
      setGetInProgress(false)
    }
  }

  return { response, getInProgress, get }
}
